import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.principal');

    core.constant(
        'INVOICE_PARAM',
        Object.freeze({
            // Définition des sections à afficher
            sections: [
                {
                    id: 'seller',
                    editable: false,
                    order: 0,
                    initClosed: true,
                },
                {
                    id: 'buyer',
                    editable: false,
                    order: 10,
                    initClosed: true,
                },
                {
                    id: 'header',
                    editable: true,
                    order: 20,
                    initClosed: false,
                },
                {
                    id: 'currency',
                    editable: true,
                    order: 30,
                    initClosed: false,
                },
                {
                    id: 'line',
                    editable: true,
                    order: 40,
                    initClosed: false,
                },
                {
                    id: 'reduction',
                    editable: true,
                    order: 50,
                    initClosed: false,
                },
                {
                    id: 'cost',
                    editable: true,
                    order: 60,
                    initClosed: false,
                },
                {
                    id: 'total',
                    editable: true,
                    order: 70,
                    initClosed: false,
                },
                {
                    id: 'tax',
                    editable: true,
                    order: 80,
                    initClosed: false,
                },
                {
                    id: 'payment',
                    editable: true,
                    order: 90,
                    initClosed: false,
                },
                {
                    id: 'footer',
                    editable: true,
                    order: 100,
                    initClosed: false,
                },
                {
                    id: 'technical',
                    editable: false,
                    order: 110,
                    initClosed: true,
                },
            ],
            // Indique quels catégories d'attributs peuvent aller dans quelle section
            // voir DSF-KISS-INIT-PArametrageDO #3.1.6.3.3
            sectionsCategories: {
                header: [
                    'invoice',
                    'identifierSeller',
                    'identifierBuyer',
                    'payment',
                    'sellerLegalEntity',
                    'sellerTaxRepresentative',
                    'buyerTaxRepresentative',
                    'sellerFactor',
                    'sellerContact',
                    'buyerContact',
                ],
                currency: ['invoice', 'total'],
                line: ['line'],
                reduction: ['reduction'],
                cost: ['cost'],
                total: ['total'],
                tax: ['tax'],
                payment: ['invoice', 'payment', 'sellerFactor'],
                footer: ['invoice', 'sellerContact', 'buyerContact'],
                technical: ['enrichedLine', 'model', 'technical', 'enrichedTotal', 'otherWorkData', 'invoice'],
            },
            zedocStandardParam: [
                { id: 'Beneficiary_Name' },
                { id: 'Beneficiary_AddressLine1' },
                { id: 'Beneficiary_AddressLine2' },
                { id: 'Beneficiary_ZipCode' },
                { id: 'Beneficiary_City' },
                { id: 'Beneficiary_Country' },
                { id: 'Recipient_GroupName' },
                { id: 'Recipient_AddressLine1' },
                { id: 'Recipient_AddressLine2' },
                { id: 'Recipient_ZipCode' },
                { id: 'Recipient_City' },
                { id: 'Recipient_Country' },
                { id: 'Heading_ContractNumber' },
                { id: 'Heading_Currency' },
                { id: 'Heading_DeliveryDate' },
                { id: 'Heading_DocumentDate' },
                { id: 'Heading_DocumentNumber' },
                { id: 'Heading_OtherNumber' },
                { id: 'Identification_Capital' },
                { id: 'Identification_IntraVATNumber' },
                { id: 'Identification_LegalStatus' },
                { id: 'Identification_SiretNumber' },
                { id: 'Orders_Number' },
                { id: 'PaymentTerms_PaymentDate' },
                { id: 'Totals_HTAmount' },
                { id: 'Totals_Monetary1' },
                { id: 'Totals_Monetary2' },
                { id: 'Totals_NetAmount' },
                { id: 'Totals_TTCAmount' },
                { id: 'Totals_VATAmount' },
                { id: 'VATRecap1_HTAmount' },
                { id: 'VATRecap1_VATAmount' },
                { id: 'VATRecap1_VATRate' },
            ],
            zedocMonoParam: [
                { id: 'Recipient_Name', format: 'Texte', type: 'Mono-occurence' },
                { id: 'Heading_Date1', format: 'Date (jour/mois/an)', type: 'Mono-occurence' },
                { id: 'Heading_Date2', format: 'Date (jour/mois/an)', type: 'Mono-occurence' },
                { id: 'Heading_Period1', format: 'Date (jour/mois/an ou mois/an)', type: 'Mono-occurence' },
                { id: 'Heading_Period2', format: 'Date (jour/mois/an ou mois/an)', type: 'Mono-occurence' },
                { id: 'Heading_Text1', format: 'Texte', type: 'Mono-occurence' },
                { id: 'Heading_Text2', format: 'Texte', type: 'Mono-occurence' },
                { id: 'Heading_Text3', format: 'Texte', type: 'Mono-occurence' },
                { id: 'Heading_Text4', format: 'Texte', type: 'Mono-occurence' },
                { id: 'Heading_Text5', format: 'Texte', type: 'Mono-occurence' },
                { id: 'Heading_Text6', format: 'Texte', type: 'Mono-occurence' },
                { id: 'Heading_QuotationCode', format: 'Texte', type: 'Mono-occurence' },
                { id: 'Heading_SupplierCode', format: 'Entier sans espace', type: 'Mono-occurence' },
                {
                    id: 'Heading_CustomerReference',
                    format: 'Alpanumérique sans espace avec [./-]',
                    type: 'Mono-occurence',
                },
                { id: 'Heading_EANClient', format: '8 ou 13 chiffres', type: 'Mono-occurence' },
                { id: 'Heading_EANSupplier', format: '8 ou 13 chiffres', type: 'Mono-occurence' },
                { id: 'Identification_Text', format: 'Texte', type: 'Mono-occurence' },
                { id: 'Options_Date1', format: 'Date (jour/mois/an)', type: 'Mono-occurence' },
                { id: 'Options_Date2', format: 'Date (jour/mois/an)', type: 'Mono-occurence' },
                { id: 'Options_Date3', format: 'Date (jour/mois/an)', type: 'Mono-occurence' },
                { id: 'Options_Date4', format: 'Date (jour/mois/an)', type: 'Mono-occurence' },
                { id: 'PaymentTerms_PaymentAmount', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_Quantity1', format: 'Entier ou décimal', type: 'Mono-occurence' },
                { id: 'Totals_Quantity2', format: 'Entier ou décimal', type: 'Mono-occurence' },
                { id: 'Totals_Quantity3', format: 'Entier ou décimal', type: 'Mono-occurence' },
                { id: 'Totals_Quantity4', format: 'Entier', type: 'Mono-occurence' },
                { id: 'Totals_OtherTTC1', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_OtherTTC2', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_OtherTTC3', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_OtherVAT1', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_OtherVAT2', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_OtherVAT3', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_OtherHT1', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_OtherHT2', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_OtherHT3', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_Monetary3', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_Monetary4', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_Monetary5', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_Monetary6', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_Monetary7', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_Monetary8', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_Monetary9', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_Monetary10', format: 'Monétaire', type: 'Mono-occurence' },
                { id: 'Totals_Packages', format: 'Entier', type: 'Mono-occurence' },
                { id: 'Totals_VATRate', format: 'Taux TVA', type: 'Mono-occurence' },
                { id: 'Identification_APECode', format: '3 chiffres + 1 lettre', type: 'Mono-occurence' },
                { id: 'Identification_SupplierCode', format: '6 chiffres', type: 'Mono-occurence' },
                { id: 'Identification_FaxNumber', format: 'Numéro téléphone', type: 'Mono-occurence' },
                { id: 'Identification_RCSNumber', format: 'Numéro RCS', type: 'Mono-occurence' },
                { id: 'Identification_RIB', format: '12 à 24 chiffres', type: 'Mono-occurence' },
                { id: 'Identification_RIBBank', format: '5 chiffres', type: 'Mono-occurence' },
                { id: 'Identification_RIBKey', format: '2 chiffres', type: 'Mono-occurence' },
                { id: 'Identification_RIBAccount', format: '11 chiffres', type: 'Mono-occurence' },
                { id: 'Identification_RIBCounter', format: '5 chiffres', type: 'Mono-occurence' },
                { id: 'Identification_PhoneNumber', format: 'Numéro téléphone', type: 'Mono-occurence' },
            ],
            zedocMultiParam: [
                { id: 'AddressBlock_AddressLine', format: 'Texte', type: 'Multi-occurence' },
                { id: 'AnotherInfos_Date1', format: 'Date (jour/mois/an)', type: 'Multi-occurence' },
                { id: 'AnotherInfos_Date2', format: 'Date (jour/mois/an)', type: 'Multi-occurence' },
                { id: 'Delivery_Date', format: 'Date (jour/mois/an)', type: 'Multi-occurence' },
                { id: 'Delivery_Number', format: 'Alphanumérique', type: 'Multi-occurence' },
                { id: 'Orders_Date', format: 'Date (jour/mois/an)', type: 'Multi-occurence' },
                { id: 'Orders_EANCode', format: '8 ou 13 chiffres', type: 'Multi-occurence' },
                { id: 'VATRecap1_VATCode', format: 'Entier sans espace', type: 'Multi-occurence' },
                { id: 'VATRecap1_TTCAmount', format: 'Monétaire', type: 'Multi-occurence' },
                { id: 'VATRecap2_HTAmount', format: 'Monétaire', type: 'Multi-occurence' },
                { id: 'VATRecap2_VATAmount', format: 'Monétaire', type: 'Multi-occurence' },
                { id: 'VATRecap2_VATRate', format: 'Taux TVA', type: 'Multi-occurence' },
                { id: 'VATRecap2_TTCAmount', format: 'Monétaire', type: 'Multi-occurence' },
            ],
            presenceOptions: [
                {
                    value: 'Non disponible',
                    model: false,
                    visible: false,
                },
                {
                    value: 'IHM SY',
                    model: true,
                    visible: true,
                },
                {
                    value: 'Enrichie',
                    model: true,
                    visible: false,
                },
            ],
        })
    );
})();
